module.exports = __webpack_public_path__ + "img/dark.944c76a7.png";